export const GERAL_TITLE = 'Geral';
export const VALOR_PF_LABEL = 'Valor limite PF';
export const VALOR_PJ_LABEL = 'Valor limite PJ';
export const PRAZO_LIMITE_TITULO = 'Prazo limite Título';
export const VALOR_MIN_PROCESSO = 'Valor mín Processo';
export const PRAZO_MAX_PAGAMENTO_PROCESSO = 'Prazo máximo para pagamento sem acréscimo no valor do Processo';
export const COBRANCA_SIMPLES_TITLE = 'Cobrança Simples';
